import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  assetId: string;
};

const [useRemoveAssetThumbnail, removeAssetThumbnail] = createAsyncAction(
  "assets/removeThumbnail",
  async ({ assetId }: Args) => {
    const res = await API.call<{ asset: string }>({
      endpoint: `assets/${assetId}/preview`,
      method: "DELETE",
    });
    return { ...res, result: res.result.asset };
  }
);

export default useRemoveAssetThumbnail;
export { removeAssetThumbnail };
